var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 95,
    height: 77.5,
    viewBox: "0 0 95 77.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23",
    "data-name": "Rectangle 23",
    width: 95,
    height: 77.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19",
    "data-name": "Rectangle 19",
    width: 95,
    height: 77,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_32",
    "data-name": "Rectangle 32",
    width: 26.83,
    height: 37.69,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "location",
    transform: "translate(-15.034 -133.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component_3_5",
    "data-name": "Component 3 \\u2013 5",
    transform: "translate(15.034 133.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    "data-name": "Group 34"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32",
    opacity: 0.65
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    "data-name": "Group 30",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    "data-name": "Group 28",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_17",
    "data-name": "Rectangle 17",
    width: 95,
    height: 77,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAF8AAABNCAYAAADAUrhlAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAX6ADAAQAAAABAAAATQAAAABM2g6TAAAHFUlEQVR4Ae2ciZLcRAxAd7mvAIEK8FvhQ8lvQVKc4Yaw6Hn8jKbHnukhXZXadqtKq+62LI+fZHmSqunbu7u7myGvhsAbLS775Ksnty3i3JcYj7983KRib6+p/AJyCbyc3xeW137OEvwyvzYpVfATdACXyoffC3gTJXBsqTe1STgLv4D+2gwZmzUnww/Xs82w/4kbzcox5tiLSdiEP4MXLLBfn5X3BGOtiSirv5zHKfdSJpDpkwsYyC9C/y4saybg7txTsAo/gRcsoN8MfSspc9SkmKhYmqRH+IBHAYz+NeufYVXWSIhPxGYCTuAX4K3wtyPYO7O+GxZlTjJIAMkhUWUCYqkbETxQgQtkgP8e+tusjNE/Qn0ipqdg7QkA2poAEZgcBzKwP5j1wWzfC5sT4FMSy5P0WPlWcwb/a9ztz6HPZ2sRkgQThj2Ro8pPVU/FU9HABfKHoR+Ffhz6cB6TDI7xVOAr/F6gxy0dCQAzfKpb8D/G+PvQH0IZ/xTKMRJAomhRJ+1nrfKBmOEDGfCfhj6aLQkgIe+HkiDicI5tp7cE5AoGJC0FsL+EAhoOFCEMEJOE79R2wjI+kqXyi6qnl1PVtJhPQoH+RejnoZ+Fkogt+HGou+/9tg3sGvxvY/1p6DehX4c+C/0ulFbEE8C7gfOOqr+sfCqWymedBNDrSQCVDnDAkwDGPA22Hfztdb1VfdzaJFY/lUzl23ZgJEfXeSp4CeMDeNZ9AmJ4EE9yLnweH+HbdkwA4FEqH/h+3RR+LHVd+UCkiunlttwYToABTit6PitVD8vMJqYHyfABL3zW8wuXBAAbpeKxPBFcPL9sYzpJb9Vv2+HmgI8C3x5PZQMeLn4RkQ0shQ+XJVaGH+sLfIICleonCBXOSwVljLLOSyYHj2n3AjzgAxThKaDNZD6wgd1aV4jlg5TwWbX6cwLyP7L8aklgzsePc3qr9rilVQG+90oS4FDyuQieyFP25m86zIXIOlCBS3BBMxc4Pqjn7M16/3KSTebFsczoJrFeHp3wWbKZIXoBLIEM5nr2JcYeJN+zHGr5cO4inLQlXsQLONdunbe3dXloS16bPM7B5yQCIgZ2PC2OPwuB/8XpEvwlegzKBHjB7LO38Usx2YJfBt0b1Je9XwszczyJuQX/xHEstCcw4LdnWh1xwK9G1d5xwG/PtDrigF+Nqr3jgN+eaXXEAb8aVXvHAb890+qIA341qvaOA357ptURB/xqVO0dB/z2TKsjDvjVqNo7DvjtmVZHHPCrUbV3HPDbM62OOOBXo2rvOOC3Z1odccCvRtXeccBvz7Q64oBfjaq944Dfnml1xAG/GlV7xwG/PdPqiAN+Nar2jgN+e6bVEQf8alTtHQf89kyrIw741ajaOw747ZlWRxzwq1G1d9yCzy/u/L2otv3V+40os8zx5G634J84xkIOlMdrvntZyxzyuOr+L8EnIJIDu3Y4Mv7KRysf7Sahc/AF7s/dnWs3g+7sgDy0Ja9NHBk+JyMGwRoIy8/c0byWfePQLiTfc2ZRw4dzF5ngp/2/DCxsNnRggweUsZqT4Dl7s4KHhVxKXnKSzdF2j/xkvRQchQ909oth3xg2d0AZmxCfHKy/wIth1yKfDLrkAzMYZfgnUEr4BuYkwQOcfWPYRwZlzK4abAWAkCjgmwjWeksEXBQrHj6yKfmwfjEBGT4XEL5ZNTi757GXGJp3ViJJbPTgngxC18ahLkT48rE4gQ4TN7VjDCvWYUeCYEnC5BvDg2T4rOTgZI4NfAhGcPaTyeAJygXKPXd6Ax+3OInwAMm902qADBv2WEPZYZA5zGAHw83WswWf4MJny6q8sVFMp4sTnIRwjDhUv+C1sdSFAB7BAtPCow1T7YB/OlsSADPh42vlx/A/WXYXZGneCwaIwKSigcvWVQ9D2Vft0WyZs74GH/A9wrfy1+ADnAQ8my1zkkJyeEJIwIv0rTKmB8jTIP0hS/Y02kp+mbJOMIK6l5g7T+nXG/i41UmADxuUXm7bsS0D3E1NWbPnw4xzTuSo8jk6Vz8geQJ4mdJW6PXARh/M1n3W3NJK+HF4kl6SYMvhpjJ82jKA6fvAptVgUVrOEfyy6uP41F6wpZhle5vz8j0geNoU8HtsObKBgRzgkr+KA1vgQLfVkCzOWZWTysdrrn5AWs3A5SkAtupeYjwhvmxztedxuNxbyfBMAK3E1mwSKEw0f72c4K9VPTRW4XMgJcAkCNlvNloTVMIu54S9j5Lh8/mZ235IwPQyTdYePyVqC3z4b8Pn4JyAyS/+2FaErQWyim/vYvXnJJgM17BH/4+zBmWz8rNzkQRBa3FlvCeZ4MYNY0u9CF1QVfB1TklgqQRezj2tNyt472uZn2sxOmd7Ffx8Yh4XScmHuhxfC3kLQhP4W8HH+nkCvDSHvCIC/wLdHMTiA1//PwAAAABJRU5ErkJggg=="
  })))))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20",
    "data-name": "Rectangle 20",
    width: 75.311,
    height: 57.025,
    rx: 8,
    transform: "translate(9.501 7.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21",
    "data-name": "Rectangle 21",
    width: 75.311,
    height: 57.025,
    rx: 8,
    transform: "translate(9.501 7.5)",
    fill: "none",
    stroke: "#838383",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M46.05,63.12s6.17,15.352,9.274,13.765S62.366,63.12,62.366,63.12",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M46.05,63.12s6.17,15.352,9.274,13.765S62.366,63.12,62.366,63.12",
    fill: "none",
    stroke: "#838383",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_57",
    "data-name": "Group 57",
    transform: "translate(49 150)",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M15.22,0C11.345,0,6.915,6.018,6.915,13.415c0,9.558,7.779,23.476,8.056,24.064.064.135.154.211.249.211a.637.637,0,0,0,.474-.211c.528-.588,12.94-14.506,12.94-24.064A13.429,13.429,0,0,0,15.22,0m0,20.442a7.027,7.027,0,1,1,7.027-7.027,7.028,7.028,0,0,1-7.027,7.027",
    transform: "translate(-1.805)",
    fill: "#3e51a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M13.166,37.479c-.277-.588-8.056-14.506-8.056-24.063C5.11,6.018,9.541,0,13.416,0A13.43,13.43,0,0,0,0,13.416c0,9.557,12.412,23.475,12.94,24.063a.64.64,0,0,0,.475.211c-.1,0-.185-.077-.249-.211",
    fill: "#d51a66"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation2);
export default __webpack_public_path__ + "static/media/location2.98a685eaa8bdf5da62a8a204814dd294.svg";
export { ForwardRef as ReactComponent };